import { useEffect, useState } from 'react';

const STORAGE_KEY = 'explore_autoplay';

const DEFAULTS = {
  enabled: true,
  timingMode: 'audio',
  fixedSeconds: 4,
  autoNext: true,
  requireExercise: false,
  exerciseTimeoutSeconds: 8,
  stopMode: 'stories',
  stopAfterStories: 5,
  stopAfterMinutes: 30,
  pauseBetweenSeconds: 3,
  characterOrder: ['vector', 'pebbles', 'milo'],
};

const listeners = new Set();

function emit() {
  listeners.forEach((fn) => fn());
}

export function getAutoplaysettings() {
  if (typeof window === 'undefined') return { ...DEFAULTS };
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULTS };
    return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULTS };
  }
}

export function saveAutoplaysettings(settings) {
  if (typeof window === 'undefined') return settings;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch {
    /* quota / private mode */
  }
  emit();
  return settings;
}

export function resetAutoplaysettings() {
  const s = { ...DEFAULTS };
  saveAutoplaysettings(s);
  return s;
}

export function useAutoplaysettings() {
  const [settings, setState] = useState(() => getAutoplaysettings());
  useEffect(() => {
    const handler = () => setState(getAutoplaysettings());
    listeners.add(handler);
    return () => listeners.delete(handler);
  }, []);
  return [settings, saveAutoplaysettings];
}
